import {ExchangeCreateElementType, ExchangeCreateType} from "../interface";

export const exchangeCreateElementInit: ExchangeCreateElementType = {
    baseExchangeRate: 0,
    cashBuyRate: 0,
    cashSellRate: 0,
    currencyType: "",
    currencyTypeName: "",
    remittanceReceiveRate: 0,
    remittanceSendRate: 0,
    usdConversionRate: 0
}

export const exchangeCreateInit: ExchangeCreateType = {
    exchangeRateDetailReqList: [
        {...exchangeCreateElementInit, currencyType: "USD", currencyTypeName: "USD(미국)"},
        {...exchangeCreateElementInit, currencyType: "CNY", currencyTypeName: "CNY(중국)"},
        {...exchangeCreateElementInit, currencyType: "HKD", currencyTypeName: "HKD(홍콩)"},
        {...exchangeCreateElementInit, currencyType: "SGD", currencyTypeName: "SGD(싱가포르)"},
        {...exchangeCreateElementInit, currencyType: "AUD", currencyTypeName: "AUD(호주)"},
        {...exchangeCreateElementInit, currencyType: "MYR", currencyTypeName: "MYR(말레이시아)"},
        {...exchangeCreateElementInit, currencyType: "INR", currencyTypeName: "INR(인도)"},
    ],
    noticeApplyTime: "",
    noticeBaseDate: "",
    noticeRound: ""
}